const { default: axiosIns } = require('@/libs/axios')

const AccountsService = {
  // GET - AccountApiController
  async searchAccounts(filter, accountId) {
    return axiosIns.get(`/accounts?term=${filter}&accountId=${accountId}`).then(response => response.data)
  },
  async getAccount(accountId) {
    return axiosIns.get(`/accounts/${accountId}`).then(response => response.data)
  },
  async getDefaultAccount() {
    return axiosIns.get('/accounts/default').then(response => response.data)
  },
  async getAccountUsers(accountId) {
    return axiosIns.get(`/accounts/users?accountId=${accountId}`).then(response => response.data)
  },
  async getUserRoles(accountId) {
    return axiosIns.get(`/accounts/roles?accountId=${accountId}`).then(response => response.data)
  },
  async getAccountInvitations(accountId) {
    return axiosIns.get(`/accounts/invitations?accountId=${accountId}`).then(response => response.data)
  },
  async rejectInvitation(id, accountId) {
    return axiosIns.patch(`/accounts/invitations/${id}?accountId=${accountId}`).then(response => response.data)
  },
  async getBalance(depositDateRange = '', withdrawDateRange = '', accountId) {
    return axiosIns.get(`/accounts/balance?accountId=${accountId}`, {
      params: {
        depositDateRange,
        withdrawDateRange,
      },
    }).then(response => response.data)
  },
  async getBilance(accountId) {
    return axiosIns.get(`/accounts/bilance?accountId=${accountId}`).then(response => response.data)
  },
  async list(term, accountId) {
    return axiosIns.get(`/accounts?accountId=${accountId}&term=${term}`).then(response => response.data)
  },
  // POST - AccountApiController
  async createAccountUser(user, accountId) {
    return axiosIns.post(`/accounts/users?accountId=${accountId}`, user).then(response => response.data)
  },
  async deposit(model, accountId) {
    return axiosIns.post(`/accounts/deposit?accountId=${accountId}`, model).then(response => response.data)
  },
  async createPaymentIntent(model, accountId) {
    return axiosIns.post(`/accounts/payment?accountId=${accountId}`, model).then(response => response.data)
  },
  async confirmPaymentIntent(transactionId, accountId) {
    return axiosIns.patch(`/accounts/payment/${transactionId}?accountId=${accountId}`).then(response => response.data)
  },
  async withdraw(model, accountId) {
    return axiosIns.post(`/accounts/withdraw?accountId=${accountId}`, model).then(response => response.data)
  },

  async create(account) {
    return axiosIns.post('/accounts', account).then(response => response.data)
  },
  // PUT - AccountApiController
  async updateAccountUser(user, accountId) {
    return axiosIns.put(`/accounts/users/${user.id}?accountId=${accountId}`, user).then(response => response.data)
  },
  async updateAccount(model, accountId) {
    return axiosIns.put(`/accounts/${model.accountId}?accountId=${accountId}`, model).then(response => response.data)
  },
  // DELETE - AccountApiController
  async removeUser(model, accountId) {
    return axiosIns.delete(`/accounts/users/${model.id}?accountId=${accountId}`).then(response => response.data)
  },
}

export default AccountsService
